import { combineReducers } from 'redux';
import applicationIdReducer from './FormStepper/applicationIdReducer';
import customerReducer from './FormStepper/customerReducer';
import formStepperReducer from './FormStepper/formStepperReducer';
import quickQuoteReducer from './FormStepper/QuickQuote/quickQuoteReducer';
import applicantDetailsReducer from './FormStepper/ApplicantDetails/applicantDetailsReducer';
import registerReducer from './FormStepper/Register/registerReducer';
import drawerReducer from './FormStepper/Drawer/drawerReducer';
import softCheckReducer from './FormStepper/SoftCheck/softCheckReducer';
import applicantIdVerificationReducer from './FormStepper/ApplicantIdVerification/applicantIdVerificationReducer';
import propertyDetailsReducer from './FormStepper/PropertyDetails/propertyDetailsReducer';
import applicantDetailsSummaryReducer from './FormStepper/ApplicantDetailsSummary/applicantDetailsSummaryReducer';
import underWrittingSummaryReducer from './FormStepper/UnderwrittingSummary/underWrittingSummaryReducer';
import selectBestOfferReducer from './FormStepper/SelectBestOffer/selectBestOfferReducer';

const appReducer = combineReducers({
    formStepperReducer,
    quickQuoteReducer,
    applicationIdReducer,
    customerReducer,
    registerReducer,
    applicantDetailsReducer,
    softCheckReducer,
    applicantDetailsSummaryReducer,
    applicantIdVerificationReducer,
    propertyDetailsReducer,
    selectBestOfferReducer,
    underWrittingSummaryReducer,
    drawerReducer,
});

export default appReducer;



// WEBPACK FOOTER //
// ./src/app/appReducer.js